const icon = require('vue-svgicon');

icon.register({
    bookings: {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `
            <path d="M7.5 4C7.77614 4 8 4.22386 8 4.5V5H16V4.5C16 4.22386 16.2239 4 16.5 4C16.7761 4 17 4.22386 17 4.5V5H18C19.1046 5 20 5.89543 20 7V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V7C4 5.89543 4.89543 5 6 5H7V4.5C7 4.22386 7.22386 4 7.5 4ZM6 6C5.44772 6 5 6.44772 5 7V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V7C19 6.44772 18.5523 6 18 6H6Z" />
            <path d="M12 12C12.2761 12 12.5 12.2239 12.5 12.5V14H14C14.2761 14 14.5 14.2239 14.5 14.5C14.5 14.7761 14.2761 15 14 15H12.5V16.5C12.5 16.7761 12.2761 17 12 17C11.7239 17 11.5 16.7761 11.5 16.5V15H10C9.72386 15 9.5 14.7761 9.5 14.5C9.5 14.2239 9.72386 14 10 14H11.5V12.5C11.5 12.2239 11.7239 12 12 12Z" />
            <rect x="6" y="7" width="12" height="1" rx="0.5" />
        `,
    },
});
